export enum RamCalculationErrorCode {
  SyntaxError = -1,
  ImportError = -2,
}
